import { useEffect, useState } from "react";
import { useAuth } from "../Context/UnifiedAuthContext";
import Loader from "./Loader/Loader";
import Modal from "./navbar/RegisterAnd Login/Modal";

const Protected = ({ children, requireAdmin = false }) => {
  const { user, isAuthenticated, isAdmin } = useAuth();
  const [showProtectedModal, setShowProtectedModal] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      setShowProtectedModal(true); // Show modal if not logged in
    } else {
      setShowProtectedModal(false);
    }
  }, [isAuthenticated]);

  const handleModalClose = () => {
    setShowProtectedModal(false);
  };

  if (!isAuthenticated) {
    return <Modal show={showProtectedModal} onClose={handleModalClose} />;
  }

  if (requireAdmin && !isAdmin) {
    return <Modal show={showProtectedModal} onClose={handleModalClose} />;
  }

  if (!user) {
    return <Loader />;
  }

  // If user is authenticated and meets admin requirement (if any), render children
  return children;
};

export default Protected;